import { PropTypes } from "base/react-libs";
import { getLatestEmployment } from "apps/home/utils/helpers";
import { formatDateFromTimestamp } from "apps/journeys/utils/helpers/dates";

const CareerMoveRowDetails = ({ contact, first, subtitle }) => {
  const { enrichment } = contact;

  const latestEmployment = getLatestEmployment(enrichment);
  const { title, company_name, start_date, confidence_score } = latestEmployment;

  return (
    <>
      {Object.values(latestEmployment).length ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          {first && <div className="homepage-recommendations-subtitle">{subtitle}</div>}
          <div>
            {title} | {company_name}
          </div>
          <div className="giving-date">
            Start Date: {formatDateFromTimestamp(start_date)} | Confidence Score: {confidence_score}
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          {first && <div className="homepage-recommendations-subtitle">{subtitle}</div>}
          <div>No career move data available</div>
        </div>
      )}
    </>
  );
};

CareerMoveRowDetails.propTypes = {
  contact: PropTypes.object,
  first: PropTypes.bool,
  subtitle: PropTypes.string,
};

export default CareerMoveRowDetails;
